import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { updateDoc, doc } from "firebase/firestore";
import { storage, db } from "./firebase";

/**
 * Uploads prequalification PDFs to Firebase Storage and updates Firestore accordingly.
 *
 * @param {string} docId - Firestore document ID for the client.
 * @param {Array} letters - Array of { loanType, pdfBytes }.
 * @param {string} transactionType - Either "Purchase" or "Refinance".
 * @returns {Promise<Object>} URLs of uploaded PDFs.
 */
async function uploadAndStorePreQualPDFs(
  docId,
  letters,
  transactionType = "Purchase"
) {
  const urls = {};

  const folderPrefix =
    transactionType === "Refinance" ? "refinance_prequal" : "prequal";

  for (const { loanType, pdfBytes } of letters) {
    const filePath = `clients/${docId}/${folderPrefix}_${loanType}.pdf`;
    const fileRef = ref(storage, filePath);

    await uploadBytes(fileRef, pdfBytes, {
      contentType: "application/pdf",
      contentDisposition: `attachment; filename=${folderPrefix}_${loanType}.pdf`,
    });

    const url = await getDownloadURL(fileRef);
    urls[loanType] = url;
  }

  const clientDocRef = doc(db, "clients", docId);

  const updateData =
    transactionType === "Purchase"
      ? {
          preQualPDFs: urls,
          preQualGeneratedAt: new Date(),
        }
      : {
          refinancePreQualPDFs: urls,
          refinancePreQualGeneratedAt: new Date(),
        };

  await updateDoc(clientDocRef, updateData);
  return urls;
}

export default uploadAndStorePreQualPDFs;
